import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=6e84ed2f&scoped=true&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=6e84ed2f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e84ed2f",
  null
  
)

export default component.exports